import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { LandingPageService } from '../services/landingpage.service';

@Injectable()
export class DataResolver implements Resolve<any> {

  constructor(private landingpageservice: LandingPageService) { }

  resolve() {
    return this.landingpageservice.getHomePageData();
  }

}